/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Step4Inputs */

const en_dr_room_step4 = /** @type {(inputs: Dr_Room_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideas`)
};

const id_dr_room_step4 = /** @type {(inputs: Dr_Room_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ide`)
};

/**
* | output |
* | --- |
* | "Ideas" |
*
* @param {Dr_Room_Step4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_step4 = /** @type {((inputs?: Dr_Room_Step4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Step4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_step4(inputs)
	return en_dr_room_step4(inputs)
});